import {
  isAskUserPartAnswered,
  parseAskUserToolInput,
  type AskUserProgress,
  type AskUserToolPart,
} from '../chat-ask-user-flow';
import { useChatToolInteraction } from '../chat-tool-interaction';
import { AskUserWidget } from './AskUserWidget';

type ChatAskUserToolProps = {
  progress?: AskUserProgress | null;
  toolPart: AskUserToolPart;
};

export function ChatAskUserTool({ progress = null, toolPart }: ChatAskUserToolProps) {
  const {
    isAskUserSubmitting,
    retryAskUserContinuation,
    submitAskUserOutput,
    toolContinuationError,
  } = useChatToolInteraction();

  const input = parseAskUserToolInput(toolPart.input);

  // Une question répondue n'est plus une carte : sa réponse est une bulle utilisateur.
  if (isAskUserPartAnswered(toolPart)) {
    return null;
  }

  // Entrée encore partielle : squelette, jamais un trou dans la conversation.
  if (!input) {
    return toolPart.state === 'input-streaming'
      ? <AskUserWidget progress={progress} state="input-streaming" onSubmit={() => undefined} />
      : null;
  }

  const hasContinuationError = toolContinuationError?.toolCallId === toolPart.toolCallId;

  const widgetState = toolPart.state === 'input-streaming' || toolPart.state === 'output-error'
    ? toolPart.state
    : 'input-available';

  return (
    <AskUserWidget
      allowFreeText={input.allowFreeText}
      allowMultiple={input.allowMultiple}
      hasContinuationError={hasContinuationError}
      isSubmitting={isAskUserSubmitting && toolPart.state === 'input-available'}
      options={input.options}
      progress={progress}
      question={input.question}
      state={widgetState}
      onRetry={retryAskUserContinuation}
      onSubmit={(nextOutput) => {
        submitAskUserOutput({
          output: nextOutput,
          toolCallId: toolPart.toolCallId,
        });
      }}
    />
  );
}
